<template>
  <div>
    <div class="form-container">
      <div class="form-title">
        <div class="divider"/>
        <div class="content">{{ formTitle }}</div>
      </div>
      <div class="info-container" v-if="infoArray && infoArray.length > 0">
        <div class="label-column">
          <span class="label" v-for="(item, index) in infoArray" :key="'label-' + index">
            {{ item.label }}：
          </span>
        </div>
        <div class="value-column">
          <span class="value" v-for="(item, index) in infoArray" :key="'value-' + index">
            {{ item.value }}
          </span>
        </div>
      </div>
      <template v-if="!isLoading">
        <slot name="result-content"></slot>
      </template>
      <div class="loading-wrap" v-if="isLoading">
        <img class="loading-img" :src="loadingImg" />
      </div>
    </div>
    
  </div>
</template>

<script>
import loadingImg from '@/assets/image/loading_icon.gif'
export default {
  name: 'CommonQuery',
  data() {
    return {
      loadingImg
    }
  },
  props: {
    formTitle: {
      type: String,
      default: ''
    },
    infoArray: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    hint: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.form-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
  border: 0.5px solid rgba(233, 234, 237, 1);
  border-radius: 6px;

  .form-title {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    color: rgba(26, 29, 37, 1);
    .divider {
      width: 2px;
      height: 12px;
      border-radius: 12px;
      background: #2290FD;
      margin-right: 8px;
    }

    .content {
      color: rgba(26, 29, 37, 1);
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      letter-spacing: 0;
      text-align: left;
    }
  }

  .info-container {
    display: flex;
    padding: 12px;
    border-radius: 6px;
    margin-bottom: 8px;
    background: #F5F7FA;

    .label-column,
    .value-column {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
    }

    .label-column {
      min-width: 52px;
      flex-shrink: 0;
      .label {
        color: #5C606A;
        font-size: 12px;
        line-height: 18px;

        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }
    }

    .value-column {
      flex: 1;
      margin-left: 12px;
      .value {
        color: #1A1D25;
        font-size: 12px;
        line-height: 18px;

        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }
    }
  }

  .loading-wrap {
    margin-top: 16px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 6px;
    padding: 0 12px;
    justify-content: center;

    img {
      height: 6px;
    }
  }
}


</style>
